import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { TitleProps } from './title.props'

export const TitleType = ComponentTypeFactory.create<TitleProps>('Title', {
  title: FieldTypeFactory.text(),
  viewAllLink: FieldTypeFactory.text({ required: false }),
  viewAllLabel: FieldTypeFactory.text({ required: false }),
  small: FieldTypeFactory.boolean({ required: false, defaultValue: false }),
  topTitle: FieldTypeFactory.boolean({
    required: false,
    defaultValue: false,
  }),
})
